var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 14 14",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m164.097047 51.9986994c-.239308.0000387-.468842-.0949406-.638153-.2640633l-3.459341-3.4587776-3.458214 3.4587776c-.228091.2280909-.56054.3171705-.872118.2336835-.311578-.0834871-.554948-.3268572-.638435-.6384351s.005592-.6440276.233683-.8721185l3.459342-3.4593419-3.458213-3.4570849c-.228091-.2280909-.317171-.5605406-.233684-.8721185.083487-.311578.326857-.5549481.638435-.6384351.311578-.0834871.644028.0055926.872119.2336834l3.457085 3.4582135 3.458213-3.4582135c.228091-.2280908.560541-.3171705.872118-.2336834.311578.083487.554949.3268571.638436.638435.083487.311578-.005593.6440277-.233684.8721186l-3.457085 3.4570849 3.458214 3.4582134c.258089.2582587.335209.6465496.195404.9838361s-.469008.5571563-.834122.5570973z",
    fill: "#ef426f",
    transform: "matrix(.70710678 .70710678 -.70710678 .70710678 -72.903382 -139.371235)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.26fcba9bcedb7aeea78a249c4e12425a.svg";
export { ForwardRef as ReactComponent };